<!-- Part of the SPARKL educational activity system, Copyright 2019 by Pepper Williams -->
<template>
	<k-container class="k-login-container" fill-height>
		<k-spacer/>
		<div class="k-login-wrapper">
			<h1 class="k-sr-only">Sign in to {{ site_config.app_name }}</h1>
			<div v-if="show_login_close_btn" style="position:absolute;right:-9px;top:-9px;"><k-btn icon color="#999" aria-label="Close sign-in panel" @click="cancel_login"><k-icon large>fas fa-circle-xmark</k-icon></k-btn></div>
			<div class="k-login-logo-wrapper"><k-spacer/>
				<img class="k-login__logo-img" :alt="site_config.agency_name + ' logo'" :src="agency_logo_img_src">
				<div class="k-login__logo-text" v-html="site_config.login_logo_text" translate="no"></div>
			<k-spacer/></div>
			<!-- <div v-if="show_login_msg" class="k-login-msg" v-html="login_msg"></div> -->
			<div v-if="friendly_login_error!=null" class="k-login-error" role="alert" aria-live="assertive" v-html="friendly_login_error"></div>
			<div class="k-login-fields-wrapper">
				<div v-for="(option, index) in login_option_order" :style="(index==0)?'margin-top:8px':'margin-top:16px;border-top:1px solid #aaa;padding-top:16px;'">
					<template v-if="option=='password'">
						<div v-if="site_config.password_login_message" class="k-login-msg mb-3"><div v-html="site_config.password_login_message"></div></div>
						<k-text-field
							@keyup="keyup"
							ref="email_field"
							class="mt-3"
							background-color="#eee"
							outlined
							hide-details="auto"
							prepend-inner-icon="fa fa-envelope"
							label="Email Address"
							autocomplete="username"
							v-bind="formFields.email"
							@input="formFields.email.input"
							@blur="formFields.email.blur"
						></k-text-field>
						<k-text-field
							@keyup="keyup"
							class="mt-4"
							background-color="#eee"
							outlined
							hide-details="auto"
							prepend-inner-icon="fa fa-key"
							:type="show_password ? 'text' : 'password'"
							:append-icon="show_password ? 'fas fa-eye' : 'fas fa-eye-slash'"
							:append-aria-label="show_password ? 'Hide password' : 'Show password'"
							:append-aria-pressed="show_password"
							@click:append="show_password = !show_password"
							label="Password"
							autocomplete="current-password"
							v-bind="formFields.password"
							@input="formFields.password.input"
							@blur="formFields.password.blur"
						></k-text-field>

						<div class="d-flex align-center mt-4">
							<div v-if="site_config.login_method=='cureum'" style="line-height:24px">
								<k-btn v-if="site_config.show_create_account_on_login=='yes'&&!site_config.down_until" text small color="primary" class="k-tight-btn k-nocaps-btn xma-0" style="font-weight:normal; font-size:14px;" @click="show_create_account_dialog=true">Create account</k-btn>
								<k-btn v-if="site_config.show_forgot_password_btn=='yes'&&!site_config.down_until" text small color="primary" class="k-tight-btn k-nocaps-btn xma-0" style="font-weight:normal; font-size:14px;" @click="forgot_password">Forgot password?</k-btn>
							</div>
							<k-spacer/>
							<k-btn @click="formHandleSubmit" color="primary" class="ml-2">Sign In<k-icon small class="ml-2">fas fa-right-to-bracket</k-icon></k-btn>
						</div>
					</template>

					<template v-if="option=='google'">
						<div v-if="site_config.google_login_message" class="k-login-msg mb-3" style="font-size:16px;"><div v-html="site_config.google_login_message"></div></div>
						<div class="d-flex"><k-spacer/><div id="g_signin_admin"></div><k-spacer/></div>
					</template>

					<!-- This is CPS-specific -->
					<template v-if="option=='oidc_ri'">
						<div v-if="site_config.oidc_ri_login_message" class="k-login-msg mb-3" style="font-size:16px;"><div v-html="site_config.oidc_ri_login_message"></div></div>
						<div class="d-flex center justify-center align-center">
							<k-btn class="k-nocaps-btn k-tight-btn" large text color="primary" dark @click="oidc_ri_sign_in" style="width:100%; height:60px; border-radius: 4px; position:relative;">
								<div style="padding-left:0px; font-size:36px;font-weight:900;">
									Sign In
									<k-btn fab color="primary" class="ml-2" @click="oidc_ri_sign_in"><k-icon class="ml-0" style="font-size:32px;">fas fa-arrow-right-to-bracket</k-icon></k-btn>
								</div>
							</k-btn>
							<!-- hidden sign-in with google button (this will not work if allow_google_login isn't 'yes' -->
							<div style="opacity:0; position:fixed; right:0px; top:0px"><div id="g_signin_admin"></div></div>
						</div>
					</template>

					<template v-if="option=='msft'">
						<div v-if="site_config.msft_login_message" class="k-login-msg mb-3" style="font-size:16px;"><div v-html="site_config.msft_login_message"></div></div>
						<div class="d-flex center justify-center align-center">
							<k-btn class="k-nocaps-btn k-tight-btn" large color="#555" dark @click="msft_sign_in" style="width:100%; height:50px; border-radius: 4px; position:relative;">
								<img src="../../images/msftlogo.png" alt="Microsoft Logo" style="width:42px; height:42px; border-radius:3px; left:-16px; top:-11px; position:absolute;"/>
								<div style="padding-left:46px; font-size:18px;">Sign in with Microsoft</div>
							</k-btn>
						</div>
					</template>
				</div>

				<div v-if="site_config.show_signin_on_load == 'yes'" class="mt-4 pt-4 mb-1 text-center" style="border-top:1px solid #aaa;"><k-btn outlined color="secondary" class="k-nocaps-btn k-tight-btn" @click="cancel_login">Open {{site_config.app_name}} in “Guest Mode”</k-btn></div>
			</div>
		</div>
		<k-spacer/>

		<div class="k-copyright">
			{{ site_config.copyright_text }} &nbsp; (v{{$store.state.app_version}})
			<span v-if="site_config.show_terms_of_service" class="ml-6">
				<k-btn x-small class="k-tight-btn k-nocaps-btn" color="white" @click="show_terms_of_service">Terms of Use / Privacy Policy</k-btn>
			</span>
		</div>

		<CreateAccount v-if="show_create_account_dialog" @dialog_cancel="show_create_account_dialog=false" />
	</k-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CreateAccount from './CreateAccount'
import { useFormMixin } from '@cglt/ui-legacy'
import { z } from 'zod'

export default {
	components: { CreateAccount },
	mixins: [
		useFormMixin({
			schema: z.object({
				email: z.string().trim().min(1, 'Please enter your email address.').email('Please enter a valid email address.'),
				password: z.string().min(1, 'Please enter your password.')
			}),
			initialValues: {
				email: U.local_storage_get('sparklsalt_login_email', ''),
				password: ''
			},
			onSubmit: function (values) {
				this.sign_in(values)
			}
		})
	],
	data() { return {
		show_password: false,
		show_create_account_dialog: false
	}},
	computed: {
		...mapState(['login_msg', 'login_error', 'site_config', 'google_client_id']),
		login_option_order() {
			// site_config will have a login_option_order array as well as individual flags saying whether or not to show each option
			// but there are also some additional constraints we take into account here
			let arr = []
			for (let option of this.site_config.login_option_order) {
				// don't show any login option if down_until is set
				if (!empty(this.site_config.down_until)) continue

				if (option == 'google') {
					// for the cps rapidid option, we don't show the normal google option -- we use a "hidden button" (see above/below)
					if (this.site_config.allow_oidc_ri_login == 'yes') continue

					// don't show google option unless allow_google_login is 'yes'
					if (this.site_config.allow_google_login != 'yes') continue
					// if the route specifies a signin_method, only show the option if the signin_method is google
					if (!empty(vapp.$route.params?.signin_method) && vapp.$route.params.signin_method != 'google') continue
				} else if (option == 'oidc_ri') {
					// don't show oidc_ri option unless allow_oidc_ri_login is 'yes'
					if (this.site_config.allow_oidc_ri_login != 'yes') continue
					// if the route specifies a signin_method, only show the option if the signin_method is oidc_ri
					if (!empty(vapp.$route.params?.signin_method) && vapp.$route.params.signin_method != 'oidc_ri') continue
				} else if (option == 'msft') {
					// don't show msft option unless allow_msft_login is 'yes'
					if (this.site_config.allow_msft_login != 'yes') continue
					// if the route specifies a signin_method, only show the option if the signin_method is msft
					if (!empty(vapp.$route.params?.signin_method) && vapp.$route.params.signin_method != 'microsoft') continue
				} else if (option == 'password'){
					// don't show password option unless allow_password_login is 'yes'
					if (this.site_config.allow_password_login != 'yes') continue
					// if the route specifies a signin_method, only show the option if the signin_method is password
					if (!empty(vapp.$route.params?.signin_method) && vapp.$route.params.signin_method != 'password') continue
				}
				// if we get to here, include the option
				arr.push(option)
			}
			return arr
		},
		friendly_login_error() {
			if (this.login_error === 'ad_fail' || this.login_error === 'sis_fail' || this.login_error === 'ic_fail_password_error' || this.login_error === 'henry_email_bad_password') {
				return null
			}
			if (this.login_error == 'ad_fail') {
				return 'Unknown email address or invalid password.'
			} else if (this.login_error == 'sis_fail' || this.login_error == 'ic_fail_password_error') {
				return 'Your email address could not be verified via your Student Information System.'
			} else if (this.login_error == 'henry_email_bad_password') {
				return 'Please sign in using the “Sign in with Microsoft” button below.'
			} else {
				return this.login_error
			}
		},
		agency_logo_img_src() {
			if (!this.site_config.agency_logo) return ''
			return this.site_config.agency_logo
		},
		showing_resource_link() {
			return (document.location.pathname.search(/\/reslink\/(.*)/) == 0)
		},
		show_login_close_btn() { 
			// return !this.showing_resource_link 
			if (this.site_config.require_sign_in == 'yes') return false
			if (this.showing_resource_link) return false
			return true
		},
		show_login_msg() {
			if (empty(this.login_msg)) return false
			// if we have a login_msg, show it UNLESS we have a specific signin_method specified
			// (we assume that this message would be explaining what option to use, so if we are specifying the signin_method it's not needed)
			if (!empty(vapp.$route.params?.signin_method)) return false
			return true
		},
	},
	created() {
		// store reference to this component in vapp for use in redirect_to_login
		vapp.login_view_component = this
	},
	watch: {
		login_error(new_error) {
			if (empty(new_error)) return

			if (new_error == 'ad_fail') {
				this.formAddError('email', 'Unknown email address')
				this.formAddError('password', 'Invalid password')
			} else if (new_error == 'sis_fail' || new_error == 'ic_fail_password_error') {
				this.formAddError('email', 'Your email address could not be verified via your Student Information System.')
			} else if (new_error == 'henry_email_bad_password') {
				this.formAddError('email', 'Please sign in using the “Sign in with Microsoft” button below.')
			}
		}
	},
	mounted() {
		// if we're using google signin, initialize it
		if (this.site_config.allow_google_login == 'yes') this.google_signin_initialize()

		// fill the "normal" login email field with the last-entered email
		if (this.site_config.allow_password_login == 'yes') {
			this.$nextTick(()=>{
				if (empty(this.$refs.email_field)) return
				this.form.values.email = this.$store.state.lst.login_email
				$(this.$refs.email_field.$el).find('input').focus()
			})
		}
	},
	methods: {
		google_signin_initialize() {
			U.loading_start()
			// google sign in should be loaded via https://accounts.google.com/gsi/client in index.html
			// if it isn't loaded yet, try again in 100 ms
			if (typeof(google) == 'undefined' || typeof(google.accounts) == 'undefined') {
				setTimeout(()=>this.google_signin_initialize(), 100);
				console.log('re-try google.accounts.id.initialize')
				return;
			}
			U.loading_stop()

			// console.log('id', this.google_client_id)

			// api docs https://developers.google.com/identity/gsi/web/reference/js-reference
			google.accounts.id.initialize({
				client_id: sr("$1.apps.googleusercontent.com", this.google_client_id),
				callback: this.handleCredentialResponse,
			})
			
			google.accounts.id.renderButton(
				document.getElementById("g_signin_admin"),
				{ 
					theme: "filled_blue", 
					size: "large",
				} 
			)
			
			// display the google One Tap dialog, unless we're told not to
			if (this.site_config.allow_google_login_one_tap == 'yes') google.accounts.id.prompt(); 
		},

		handleCredentialResponse(response) {
			//console.log("Encoded JWT ID token: " + response.credential);
			let id_token = response.credential
			if (id_token) {
				// pass id_token back to initialize_portal service, which will sign the user in
				vapp.initialize_app({google_id_token: id_token})
			} else {
				// TODO: what do we do here?
				alert('Google sign in handleCredentialResponse failed')				
			}
        },

		forgot_password() {
			this.$prompt({
				title: 'Forgot Password',
				text: 'Enter your email address and click the button below to send a one-time sign-in link to your email account. <b>This link will be valid for one hour.</b> After using the link to sign in, you can reset your password.',
				initialValue: this.email,
				acceptText: 'Send One-Time Sign-In Link',
				dialogMaxWidth: 540,
				focusBtn: true,		// focus on the accept btn when dialog is rendered
			}).then(fp_email => {
				U.loading_start()
				U.ajax('send_token_signin_email', {user_email: fp_email, token_duration: 60}, result=>{
					U.loading_stop()
					let msg
					if (result.status != 'ok') {
						if (result.status === 'bad_email') {
							msg = 'We couldn’t find an account for the email you entered.'
						} else {
							//msg = result.status
							msg = 'The one-time sign-in link could not be sent.'
						}
						console.log('Error in token signin ajax call: ' + result.status)	
					} else {
						msg = 'One-time sign-in link sent. <b>Please check your spam or junk folder</b> if you don’t receive the link within one minute, and remember that <b>the link will expire after one hour</b>.'
					}
					this.$alert(msg)
				})
			}).catch(n=>{console.log(n)}).finally(f=>{})
		},

		show_password_login() {
			this.$store.commit('set', [this.site_config, 'allow_password_login', 'yes'])
		},

		keyup(event) {
			if (event.code == 'Enter' || event.keyCode == 13) this.formHandleSubmit()
		},

		sign_in(values) {
			values.email = $.trim(values.email)
			values.password = $.trim(values.password)

			// READY TO SIGN IN...

			// store email in local storage
			this.$store.commit('lst_set', ['login_email', values.email])
			vapp.initialize_app({
				email: values.email,
				password: values.password,
			})
		},

		// Microsoft OIDC sign in
		msft_sign_in() {
			// READY TO SIGN IN...
			window.location.href = '/src/saml/login.php'
		},

		// Rapid Identitiy OIDC sign in (CPS)
		oidc_ri_sign_in($evt) {
			// back-door: show the sign in fields if shift and cmd are held down
			if ($evt && $evt.shiftKey && $evt.metaKey) {
				this.site_config.allow_password_login = 'yes'
				this.site_config.login_option_order.push('password')

			} else {
				vapp.cps_oidc_login()
			}
		},

		cancel_login() {
			vapp.app_mode = 'main'
		},

		show_terms_of_service() { vapp.show_terms_of_service() },
	},
}
</script>

<style lang="scss">
.k-login-container {
	max-width:100vw;
	width:100vw;
}

.k-login-wrapper {
	position:relative;
	border-radius:8px;
	background:rgba(255, 255, 255, 0.9);
	padding:10px;

	.k-login-fields-wrapper {
		margin-top:10px;
		padding:2px 8px 8px 8px;
		border-radius:8px;
		background:rgba(255, 255, 255, 0.9);
		min-width:400px;
	}

	.k-login__logo-text {
		font-family: var(--agency-name-font-family);
	}

	.k-login__logo-img {
		height:90px;
		// margin-left:5px;
		margin-top:20px;
	}
}

.k-login-msg {
	background-color:$v-blue-lighten-4;
	color:$v-blue-darken-4;
	border-radius:5px;
	padding:8px 12px;
	max-width: 500px;
	margin-left:auto;
	margin-right:auto;
	font-size: 15px;
	line-height:20px;
}

.k-login-error {
	background-color:$v-red-lighten-4;
	color:$v-red-darken-4;
	border-radius:5px;
	padding:10px;
	margin: 10px 0 10px 0;
	max-width: 500px;
	font-size: 15px;
	line-height:20px;
}

.k-login-logo-wrapper {
	// width:500px;
	display:flex;
	justify-content:space-between;
	// align-items: center;
	font-size:40px;
	font-weight:bold;
	color: $v-doe-dark-pink;
	line-height:36px;
	margin-bottom:20px;
	position:relative;
}

.k-google_signin_btn {
	// cursor:pointer;
	// width:240px;
	// transform: scale(1.9);
}
</style>
